export default {"src":"/_next/static/media/noun_Book_5020.e7e57b31.svg","height":100,"width":100,"blurWidth":0,"blurHeight":0};